import React from 'react'

import FormManager from '../../../../gd-form/common/form-manager'
import CustomFieldAddFormProto, {CustomFieldAddFormProto_Props} from "../../add-form-proto"
import CustomFieldLeftPanel from "../../common/panel/form-left-panel"
import CustomFieldRightPanel from "../../common/panel/form-right-panel"
import CustomFieldPreview from "../../common/form-preview"
import CustomFieldDecimalPlaces from "../../common/form-decimal-places"
import CustomFieldPositiveOnly from "../../common/form-positive-only"
import CustomFieldIntegersOnly from "../../common/form-integers-only"


export default class NumberCustomFieldForm extends CustomFieldAddFormProto {

    public form: FormManager

    constructor(props: CustomFieldAddFormProto_Props) {
        super(props);

        this.type = gd.const.customFields.type.NUMBER

        this.initFormData.decimalPlaces = null
        this.initFormData.positiveOnly = false
        this.initFormData.integersOnly = false

        if (this.props.customField) {
            this.initFormData.decimalPlaces = _.get(this.props.customField.params,'decimalPlaces', null)
            this.initFormData.positiveOnly  = _.get(this.props.customField.params,'positiveOnly', false)
            this.initFormData.integersOnly  = _.get(this.props.customField.params,'integersOnly', false)
        }

        this.state = {
            noDecimalPlaces: this.initFormData.integersOnly
        }

        this.formStructure.fields.decimalPlaces = {
            type: 'select',
            isRequired: false,
            label: 'Decimal places',
            onUserChange: () =>  this.setState({reRender: 1})
        }

        this.formStructure.fields.positiveOnly = {
            type: 'select',
            isRequired: true,
            label: 'Positive only'
        }

        this.formStructure.fields.integersOnly = {
            type: 'select',
            isRequired: true,
            label: 'Integers only',
            onUserChange: () => {
                // hide decimal places and set no 0 if integersOnly is true
                this.form.setValue('decimalPlaces', 0)
                this.setState({noDecimalPlaces: this.form.getValue('integersOnly')})
            }
        }

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result: any) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.NUMBER;

        result.params = {
            displayName     : result.displayName?.trim(),
            decimalPlaces   : result.decimalPlaces,
            scope           : result.scope,
            positiveOnly    : result.positiveOnly,
            integersOnly    : result.integersOnly
        }

        this.props.onSubmit(result);
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        <div className="txt m-l-15">{gd.utils.Format.number(1234.56,this.form.getValue('decimalPlaces'),false)}</div>
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}>
                    <CustomFieldPositiveOnly form={this.form}/>
                    <CustomFieldIntegersOnly form={this.form}/>

                    {!this.state.noDecimalPlaces &&
                        <CustomFieldDecimalPlaces form={this.form}/>}
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}